import React, { FC } from "react";

export const RequiredSign: FC = () => (
	<div className="text-red text-lg leading-5 ml-0.5">
		<span>*</span>
	</div>
);
